
    import Vue from "vue";
    import { Prop, Watch, Component } from "vue-property-decorator";
    import * as Articulos from '@lib/Articulos';
    import { Articulo } from '@lib/Articulos';
import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue {


        @Prop( { type: Boolean } ) public disabled: boolean;
        @Prop( { type: Boolean } ) public readonly: boolean;
        @Prop( { type: Boolean, default: true } ) public outlined: boolean;
        @Prop( { type: Boolean, default: true } ) public dense: boolean;
        @Prop( { type: Boolean, default: true } ) public clearable: boolean;
        @Prop( { type: Boolean, default: false } ) public details: boolean;
        @Prop( { type: String, default: 'Artículo:' } ) public prefix: string;
        @Prop( { type: String, default: '' } ) public label: string;

        @Prop( { type: Articulo } )
        public value: Articulo;

        @Watch( 'value', { immediate: true } )
        onIndex() {
            this.Selected = this.value;

        }

        constructor() {
            super();
        }

        public Items: Articulo[] = [];

        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar() {

            if ( this.Estado === 'cargando' )
                return;

            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                this.Estado = 'cargando';
                let e = await Articulos.Articulo.find( { q: this.Busqueda } );
                this.Items = e.Items;
                this.Estado = 'ok';
            }

        }

        filter( item: any, queryText: string, itemText: string ) {
            if ( item && queryText ) {
                const searchText = queryText.toLowerCase();
                return String( item.Id ).includes( searchText ) || String( item.Id ).includes( searchText.formatearCodigoArticulo() ) || String( item.Descripcion ).toLowerCase().includes( searchText );
            }
            return false;
        };


        public selected: Articulo | null = null;
        public get Selected(): Articulo | null {
            return this.selected;
        }
        public set Selected( x: Articulo | null ) {
            this.selected = x;
            this.$emit( 'input', this.Selected );
        }

        public async onLostFocus( event: any ) {

        }

        public async onEnter()
        {
            let b = this.Busqueda;
            if ( b )
            {
                console.log(b );
                let a = await Articulo.create( b )
                console.log( a );
                if ( a )
                {
                    this.Selected = a;
                } else
                {
                    this.Busqueda = '';
                }
            }

        }

        public Estado: 'cargando' | 'ok' | 'error' | 'vacio' | 'iniciado' = 'iniciado';
    }
